import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './components/Login.vue'
import Index from './components/Index.vue'
import Eles from './components/ui/Eles.vue'
import Result from './components/ui/Result.vue'
import Cases from './components/ui/Case.vue'

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'hash',
    routes: [
    {
        path: '/',
        name: 'login',
        component: Login
    },
    {
        path: '/index',
        name: 'index',
        component: Index,
        children:
        [
            {
                path: 'Eles',
                name: 'Eles',
                component: Eles,
                meta: {
                    title: '元素库'
                }
            },
            {
                path: 'Result',
                name: 'Result',
                component: Result,
                meta: {
                    title: '运行结果'
                }
            },
            {
                path: 'Cases',
                name: 'Cases',
                component: Cases,
                meta: {
                    title: '用例库'
                }
            }
        ]
    }
    ]
})



// WEBPACK FOOTER //
// ./src/router.js